import { createReducer, on } from '@ngrx/store';
import {
  deleteAppConfigKeys,
  getAppConfigKeys,
  saveAppConfigKeys,
  setAppConfigKeys,
  setEnvironments
} from '../actions/appconfigkeys.actions';

export interface AppConfigKeysState {
  data: any;
}

export const initialState: AppConfigKeysState = {
  data: {}
};

export const appconfigkeysReducer = createReducer(
  initialState,
  on(getAppConfigKeys, (state, { apiConstants }) => ({
    ...state,
    ...apiConstants
  })),
  on(saveAppConfigKeys, (state, { appconfigkeysData }) => ({
    ...state,
    ...appconfigkeysData
  })),
  on(setEnvironments, (state, { environmentsTable }) => ({
    ...state,
    ...{ environmentsTable }
  })),
  on(setAppConfigKeys, (state, { appconfigkeysTable }) => ({
    ...state,
    ...{ appconfigkeysTable }
  })),
  on(deleteAppConfigKeys, (state, { appconfigkeysId }) => {
    return {
      ...state,
      appconfigkeysId
    };
  })
);
